const LockIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 { fill: #fcfcfc; }
        .cls-2 { fill: #4d4d4d; }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 { fill: #fdfdfd; }
      `}</style>
    </defs>

    <g>
      <circle className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path className="cls-1" d="M550.64,596.07c-15.99,18.47-35.45,26.92-59.49,26.76-66.9-.43-133.81-.14-200.72-.17-27.73,0-56.34-23.07-57.24-50.77-1.82-55.57-1.63-111.26-.67-166.86.52-30.01,17.97-49.1,46.25-58.39,1.31-.43,2.58-1,4.2-1.63,0-23.16-.41-46.22.08-69.26,1.13-52.82,32.26-92.93,83.43-105.44,47.14-11.52,97.69,3.37,127.66,46.76,11.82,17.11,16.47,36.42,16.67,56.89.23,23.92.05,47.85.05,69.87,14.5,6.01,25.41,11.97,33.44,20.36.86.9,1.77,1.77,2.7,2.6,11.3,10.03,16.01,24.32,16.11,39.42.33,49.59.1,99.2.04,148.79-.02,14.71-3.96,28.29-12.52,41.07ZM262.07,550.77c.01,2.88.35,5.81-.02,8.64-2.22,17.04,14.31,33.75,33.52,33.75,67.72.03,135.44-.1,203.16-.5,19.63-.12,33.31-14.54,33.33-34.05.06-50.14.05-100.29,0-150.43,0-3.11-.16-6.34-1.02-9.29-4.08-14.05-15.79-21.81-34.11-21.84-67.43-.11-134.87-.08-202.3.16-21.54.08-32.51,11.77-32.53,33.52-.03,46.11-.03,92.22-.04,140.04ZM358.1,205.41c-21.43,10.5-38.85,26.19-41.66,50.15-3.49,29.81-2.38,60.16-3.25,90.25h166.97c0-25.82.51-50.6-.19-75.34-.44-15.42-5.38-29.88-15.72-41.77-27.91-32.07-65.79-40.65-106.15-23.3Z" />
      <path className="cls-5" d="M416.29,501.1c-1.38,2.92-2.65,5.47-2.79,8.08-.48,9.5-.48,19.02-.86,28.52-.41,10.23-7.37,16.86-17.02,16.49-8.93-.35-14.25-6.46-14.04-16.97.22-10.93.97-21.84,1.5-32.75-19.41-9.33-27.02-33.23-16.07-54.45,7.68-14.88,22.85-21.4,39.26-17.7,14.67,3.31,26.17,17.37,27.19,32.86.99,14.96-3.99,27-17.18,35.92Z" />
    </g>
  </svg>
);

export default LockIcon;